module.exports = "/_next/static/images/9ee3fadd7eab0650cdbf7f845de185b4-mastercard-right-lg.jpg.webp";